import {SavedSearchInfo, TableSavedSearch} from '../typedef';

export const createBaseTableSearch = (item: {savedSearchInfo: SavedSearchInfo}): TableSavedSearch => {
    const s = item.savedSearchInfo;
    const rawCode = s.searchType;

    return {
        id: s.id,
        name: s.name,
        alert: s.alert,
        searchTypeCode: rawCode || '',
        createdAt: s.createdAt,
        lastRunAt: (s.lastRunAt ?? null) as string | null,
        lastSharedAt: (s.lastSharedAt ?? null) as string | null,
        lastUpdatedAt: (s.lastUpdatedAt ?? null) as string | null,
        alertCount: s.alertCount,
        searchTotalCount: s.searchTotalCount,
    };
};
